var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("gg-modal", {
    attrs: {
      "is-active": _vm.isActive
    },
    on: {
      close: _vm.close
    },
    scopedSlots: _vm._u([
      {
        key: "toolbar",
        fn: function fn() {
          return [_vm._v(" Delete Alias? ")]
        },
        proxy: true
      },
      {
        key: "body",
        fn: function fn() {
          return [
            _vm._v(
              " Are you sure you want to delete the alias “" +
                _vm._s(_vm.alias && _vm.alias.dest) +
                "”? Mail sent to it will no longer reach " +
                _vm._s(_vm.mailbox.email) +
                ". "
            )
          ]
        },
        proxy: true
      },
      {
        key: "actions",
        fn: function fn() {
          return [
            _c("v-spacer"),
            _c(
              "gg-btn",
              {
                attrs: {
                  secondary: ""
                },
                on: {
                  click: _vm.close
                }
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "gg-btn",
              {
                attrs: {
                  primary: "",
                  loading: _vm.deleting
                },
                on: {
                  click: _vm.remove
                }
              },
              [_vm._v("Delete")]
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }